import { render, staticRenderFns } from "./pageBanner.vue?vue&type=template&id=6663143e&scoped=true&"
import script from "./pageBanner.vue?vue&type=script&lang=js&"
export * from "./pageBanner.vue?vue&type=script&lang=js&"
import style0 from "./pageBanner.vue?vue&type=style&index=0&id=6663143e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6663143e",
  null
  
)

export default component.exports